import { Grid, Typography } from '@mui/material';

export function LegacyExamination({ neurologicalExamination }) {
  return (
    <>
      <Grid item xs={4}>
        <Typography>Aphasia</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.aphasia}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Dysarthria</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.dysarthria}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Facial Droop</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.facialDroop?.side + ' - ' + neurologicalExamination.facialDroop?.severity}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Arm weakness</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.armWeakness ? neurologicalExamination.armWeakness?.side + ' - ' + neurologicalExamination.armWeakness?.level : 'NOT PROVIDED'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography>Hemineglect</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={{ textAlign: 'right' }}>{neurologicalExamination.hemineglect}</Typography>
      </Grid>
    </>
  );
}
